import {
  LAYOUT_LIST,
  TEXT,
  ACCORDION,
  ACCORDION_ITEM,
  LayoutListDefinition
} from '../items';
import { Translator } from '../Translator';
import { CardHelper } from './itemHelpers/CardHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import {
  optionalFieldsInEditor,
  optionalFieldValues
} from '../utils/optionalFields';

export const Interactive1: Translator = sequence => {
  const columns = {
    type: LAYOUT_LIST,
    id: `${sequence.id}-columns`,
    items: [],
    values: {
      align: 'center',
      height: '100%',
      padded: false
    }
  } as LayoutListDefinition;

  /*
  ENG-9394
  No Next button - learners can't move past slide - Workramp

  We received a request from another company, and there is a conflict in behavior.

  By default, we keep the current logic, where the user must open all elements.

  However, if the sequence contains an element with the type QUESTION,
  then the learner can open only one element, and the Next button will appear.
  */

  const questionExists =
    sequence?.items?.some(item => item.__typename === 'Question') || false;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'List':
        return {
          id: item.id,
          type: LAYOUT_LIST,
          values: {
            align: 'center',
            height: '100%'
          },
          items: [
            CardHelper(
              {
                title: item.title,
                subtitle: item.subtitle,
                icon: item?.icon,
                // The card's texts save to `${id}_title` / `${id}_subtitle`.
                id: item.id
              } as ItemOfType<'Card'>,
              {
                height: 'unset',
                width: { _: '95%', md: '70%' },
                padding: { _: '0px', md: '24px' },
                optional: ['subtitle', 'title'],
                extraItems: [
                  {
                    type: ACCORDION,
                    id: item.id,
                    items:
                      item?.items?.map(item => {
                        return {
                          type: ACCORDION_ITEM,
                          id: item.id,
                          values: {
                            id: `${item.title}_title`,
                            value: item.title,
                            expandAllItems: !questionExists
                          },
                          items: [
                            {
                              type: TEXT,
                              id: `${item.id}_body`,
                              items: [],
                              values: {
                                ...optionalFieldValues(
                                  optionalFieldsInEditor(['body']),
                                  'body'
                                ),
                                value: item.body
                              }
                            }
                          ]
                        };
                      }) || [],
                    values: void 0
                  }
                ]
              }
            )
          ]
        };
      default:
        return null;
    }
  });

  root.items.push(columns);
  return root;
};
